import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { getCard } from "../../../services/api/banking/cards";

export const QUERY_CARD = "QUERY_CARD";

export const useQueryCard = (
  cardId: string,
  config?: WSQueryConfig<cardApiSpec.Card, WSServiceError>
) => {
  return useWSQuery<cardApiSpec.Card, WSServiceError>(
    [QUERY_CARD, cardId],
    () => getCard(cardId),
    {
      retry: false,
      ...config
    }
  );
};
